var render, staticRenderFns
import script from "./SortableList.vue?vue&type=script&lang=ts&"
export * from "./SortableList.vue?vue&type=script&lang=ts&"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=4476bbcf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports